import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_MATCH_BIOSEC_FETCH = 'TRN_MATCH_BIOSEC_FETCH'
export const TRN_MATCH_BIOSEC_FETCH_CANCELED = 'TRN_MATCH_BIOSEC_FETCH_CANCELED'
export const TRN_MATCH_BIOSEC_FETCH_ERROR = 'TRN_MATCH_BIOSEC_FETCH_ERROR'
export const TRN_MATCH_BIOSEC_FETCH_FULFILLED = 'TRN_MATCH_BIOSEC_FETCH_FULFILLED'

export const matchBiosecurityFetch = (matchId) => ({
  payload: { matchId },
  type: TRN_MATCH_BIOSEC_FETCH,
})

export const matchBiosecurityFetchFulfilled = (payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_FETCH_FULFILLED,
})

export const matchBiosecurityFetchCanceled = () => ({
  payload: null,
  type: TRN_MATCH_BIOSEC_FETCH_CANCELED,
})

export const matchBiosecurityFetchError = (payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_FETCH_ERROR,
})

export const matchBiosecurityFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_MATCH_BIOSEC_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/soccer/match/${action.payload.matchId}/biosecurity`, action).pipe(
        map(epicResponseHandler(matchBiosecurityFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_MATCH_BIOSEC_FETCH, TRN_MATCH_BIOSEC_FETCH_CANCELED))),
        catchError(epicErrorHandler(matchBiosecurityFetchError, action)),
      ),
    ),
  )
